import React from 'react'
import loaderSpinner from 'Assets/Images/spooky-loader.svg'
import injectStyles from 'react-jss'
import { Tr } from 'Components/Table'
import { Td } from 'Components/Table'

const styles = {
  errorIcon: {
    color: 'red',
    fontWeight: 'bold',
    fontFamily: 'Courier New',
    height: 16,
  },
  tickIcon: {
    color: 'green',
    fontWeight: 'bold',
    fontFamily: 'Courier New',
    height: 16,
  },
  error: {
    color: 'red',
  },
  loadingSpinner: {
    height: 16,
  },
}

const SyncRequestRow = ({ syncing, url, method, errorMessage, classes }) => {
  return (
    <Tr>
      <Td>
        {(() => {
          if (syncing === true)
            return (
              <img
                className={classes.loadingSpinner}
                alt="loading"
                src={loaderSpinner}
              />
            )
          if (errorMessage) return <span className={classes.errorIcon}>✘</span>
          if (syncing === false)
            return <span className={classes.tickIcon}>✓</span>
          return '-'
        })()}
      </Td>
      <Td>{method || '-'}</Td>
      <Td>{makeUrlMoreReadble(url)}</Td>
      <Td>
        <span className={classes.error}>{errorMessage}</span>
      </Td>
    </Tr>
  )
}

export default injectStyles(styles)(SyncRequestRow)

/**
 * If its a known endpoint like the api end point will strip that out
 * the url to make it more readable
 * @param {string} url
 * @returns {string}
 */
function makeUrlMoreReadble(url) {
  if (!url) return '-'
  return '/' + getUrlPath(url)
}

/**
 * Gets the path part of a url
 * @param {string} url
 * @returns {string}
 */
const getUrlPath = function(url) {
  return (
    url
      // Take out the hostname
      .replace(/^https?:\/\//, '')
      .replace(/^.*?\//, '')
  )
}
